export default __webpack_public_path__ + "static/media/section-6.86f19d86.png";